import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-32 md:py-48 relative bg-background border-b border-border" data-id="element-15">
      <div className="container mx-auto px-6 md:px-12" data-id="element-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-0" data-id="element-17">
          <div className="lg:col-span-4 flex flex-col justify-between" data-id="element-18">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 1
          }} data-id="element-19">
              <h2 className="text-secondary uppercase tracking-super-wide text-[10px] font-sans mb-6" data-id="element-20">
                Про агенцію
              </h2>
              <div className="w-16 h-[1px] bg-border" data-id="element-21"></div>
            </motion.div>

            <motion.div className="hidden lg:block mt-auto" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            delay: 0.4
          }} data-id="element-22">
              <p className="text-secondary font-sans text-[11px] uppercase tracking-widest leading-loose" data-id="element-23">
                Засновано в Києві
                <br data-id="element-24" />
                Працюємо по всьому світу
              </p>
            </motion.div>
          </div>

          <div className="lg:col-span-8" data-id="element-25">
            <motion.h3 className="text-4xl md:text-5xl lg:text-7xl font-serif leading-tight text-primary" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 1,
            delay: 0.2
          }} data-id="element-26">
              Ми створюємо{' '}
              <span className="italic text-secondary" data-id="element-27">архітектуру</span>{' '}
              вражень. Кожна деталь продумана.
            </motion.h3>

            <motion.div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-12 text-secondary font-sans font-light text-sm md:text-base leading-relaxed" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 1,
            delay: 0.4
          }} data-id="element-28">
              <p data-id="element-29">
                Наша філософія базується на бездоганному сервісі та естетиці
                преміум-класу. Ми віримо, що справжня розкіш полягає в
                непомітних деталях та ідеальному таймінгу.
              </p>
              <p data-id="element-30">
                Маючи понад 10 років досвіду, ми зібрали команду
                перфекціоністів, які перетворюють найсміливіші ідеї на
                бездоганну реальність.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}